import React, { useCallback, useEffect } from 'react';
import { createPortal } from 'react-dom';

export default function PopupContainer({ isOpen, onClose, children }) {
  const handleKeyDown = useCallback(
    (event) => {
      if (event.key === 'Escape') {
        onClose?.();
      }
    },
    [onClose]
  );

  useEffect(() => {
    if (!isOpen) return;
    document.addEventListener('keydown', handleKeyDown);
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
      document.body.style.overflow = previousOverflow || 'unset';
    };
  }, [isOpen, handleKeyDown]);

  if (!isOpen) return null;

  const handleBackdropClick = (event) => {
    if (event.target === event.currentTarget) {
      onClose?.();
    }
  };

  return createPortal(
    <div
      className="fixed inset-0 z-50 bg-black/75 flex items-center justify-center"
      onClick={handleBackdropClick}
    >
      {children}
    </div>,
    document.body
  );
}
